import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgHiReply({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 12 11"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.3949 0.805048C4.52613 0.936318 4.59985 1.11433 4.59985 1.29995C4.59985 1.48556 4.52613 1.66358 4.3949 1.79485L2.7898 3.39995H6.7C7.99956 3.39995 9.24589 3.9162 10.1648 4.83513C11.0837 5.75405 11.6 7.00039 11.6 8.29995V9.69995C11.6 9.8856 11.5262 10.0636 11.395 10.1949C11.2637 10.3262 11.0857 10.3999 10.9 10.3999C10.7143 10.3999 10.5363 10.3262 10.405 10.1949C10.2737 10.0636 10.2 9.8856 10.2 9.69995V8.29995C10.2 7.37169 9.83125 6.48145 9.17487 5.82507C8.51849 5.1687 7.62826 4.79995 6.7 4.79995H2.7898L4.3949 6.40505C4.46175 6.46962 4.51508 6.54686 4.55177 6.63227C4.58845 6.71767 4.60777 6.80952 4.60857 6.90247C4.60938 6.99541 4.59167 7.08759 4.55647 7.17362C4.52128 7.25964 4.4693 7.3378 4.40357 7.40352C4.33785 7.46925 4.25969 7.52123 4.17367 7.55642C4.08764 7.59162 3.99546 7.60933 3.90252 7.60852C3.80957 7.60772 3.71772 7.58841 3.63231 7.55172C3.54691 7.51503 3.46967 7.46171 3.4051 7.39485L0.605097 4.59485C0.473867 4.46358 0.400146 4.28556 0.400146 4.09995C0.400146 3.91433 0.473867 3.73632 0.605097 3.60505L3.4051 0.805048C3.53637 0.673818 3.71438 0.600098 3.9 0.600098C4.08561 0.600098 4.26363 0.673818 4.3949 0.805048Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgHiReply;
